<template>
	<span class="equal-sign">=</span>
</template>
<script type="text/javascript">
	export default{
		name:'equal-sign'
	};
</script>